var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_stroke",
    cx: 21.2,
    cy: 21.2,
    r: 17.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_orange",
    d: "M23 25.3h-3.5c-.8 0-1.4-.6-1.4-1.4V10.2c0-.8.6-1.4 1.4-1.4H23c.8 0 1.4.6 1.4 1.4v13.7c0 .8-.6 1.4-1.4 1.4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_fill_orange",
    cx: 21.2,
    cy: 31.3,
    r: 3.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.f8ecbe933279556e0a50dde490a504c2.svg";
export { ForwardRef as ReactComponent };